import React from "react";
import get from "lodash/get";
import { StoryElement } from "@quintype/components";
import { DefaultStoryCard } from "../../DefaultStoryCard";
import { isTemplateWithAds } from "../../../utils/story";
import { WithStoryAds } from "../../WithStoryAds";
import "./highlights.m.css";

export default function Highlights({ story, card, counter = {} }) {

  const customStoryElements = card["story-elements"];
  const highlightEle = {};

  customStoryElements.map((element) => {
    if (element.type === "title") {
      highlightEle.title = get(element, ["text"], "");
    }
    if (element.type === "text") {
      highlightEle.textEle = element;
    }
  });
const showDefault = !highlightEle?.title || !highlightEle?.textEle;

  const componentToRender = (
    <div className="story-element story-element-highlights" styleName="highlight-wrapper">
      <p styleName="header">{highlightEle?.title}</p>
      <div styleName="styled-bullets">
        <StoryElement element={highlightEle?.textEle} story={story} />
      </div>
    </div>
  );

  const enableParagraphAds = isTemplateWithAds(story);
  if (showDefault) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }
  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
}
